var Graphi = {
	getScrollBarWidth : function(){
		var inner = document.createElement('p');
		inner.style.width = "100%";
		inner.style.height = "200px";
	
		var outer = document.createElement('div');
		outer.style.position = "absolute";
		outer.style.top = "0px";
		outer.style.left = "0px";
		outer.style.visibility = "hidden";
		outer.style.width = "200px";
		outer.style.height = "150px";
		outer.style.overflow = "hidden";
		outer.appendChild (inner);
	
		document.body.appendChild (outer);
		var w1 = inner.offsetWidth;
		outer.style.overflow = 'scroll';
		var w2 = inner.offsetWidth;
		if (w1 == w2)
			w2 = outer.clientWidth;
	
		document.body.removeChild (outer);
	
		return (w1 - w2);
	},
	randomString : function(){
		var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
		var string_length = 8;
		var randomstring = '';
		for (var i=0; i<string_length; i++) {
			var rnum = Math.floor(Math.random() * chars.length);
			randomstring += chars.substring(rnum,rnum+1);
		}
		return randomstring;
	},
	parseTranslation : function(translation){
		var translationArray = {
		    x : 0,
		    y : 0
		}
		if(translation){
    		for (var i = 0; i < translation.length; i = i+3 ){
    		    if (translation[i] == "t" || translation[i] == "T"){
    		        if(translation[i+1]){
    		            translationArray.x += translation[i+1];
    		        }
    		        if(translation[i+2]){
        		        translationArray.y += translation[i+2];
                    }
    		    }
    		}
		}
		return translationArray;
		
	},
	parseRotation : function(string){
		var matches =  /rotate\((\d+(\.\d+)?)(\,\s*(\d+(\.\d+)?))?(\,\s*(\d+(\.\d+)?))?\)/ig.exec(string);
		var ret  = matches != null ? [	matches[1].toInt() ] : [0];
		if(matches != null && matches[4] != null) {
			ret.push(matches[4].toInt(), matches[7].toInt());
		}
		return ret;
	},
	updateRotation : function(string , r , cx , cy){
		var rot = Graphi.parseRotation(string);
		var tras = Graphi.parseTranslation(string);
	
		var trans = '';
		trans += "rotate("+r;
		if(cx)
			trans+= ","+cx+","+cy;
		trans += ') ';
		// se 'è traslazione
		if(tras) {
			trans += "translate("+tras[0]+", "+tras[1]+")";
		}
		return trans;
	},
	updateTranslation : function(string , x , y){
		var rot = Graphi.parseRotation(string);
		var tras = Graphi.parseTranslation(string);
	
		var trans = '';
		trans += "translate("+x+","+y+") ";
	
		// se c'è rotazione
		if(rot) {
			trans += "rotate("+rot[0];
			if(rot[1])
				trans += ","+rot[1]+","+rot[2];
			trans += ")"
		}
		return trans;
	},
	adjustInterface : function(){
		var thumbGallery = $('pageThumbs');
		var spreadContainer = $('pageContainer');
		var toolbarsHeight = $$('.ui-layout-north')[0].getSize().y + $$('.topC')[0].getSize().y + $$('.topCentro')[0].getSize().y + $$('.bottomCentro')[0].getSize().y + $$('.ui-layout-pane-south')[0].getSize().y;
		var windowHeight = window.getSize().y;
		var windowWidth = window.getSize().x;
		var topCentroWidth = $$('.topCentro')[0].getSize().x;
		/*spreadContainer.setStyle('height' , windowHeight - toolbarsHeight -60);
		spreadContainer.setStyle('width' , topCentroWidth);
		//$('layoutArea').setStyle('height' , windowHeight - toolbarsHeight -60);			
		*/
	},
	getDistance : function(x1,y1,x2,y2){
        return Math.sqrt((x1-x2) * (x1-x2) + (y2-y1) * (y2-y1));
    }
}
